export class ConteudoTab {
    htmlRender = null;
    elementId = null;

    constructor(nomeClasse) {
        this.nomeClasse = nomeClasse;
    }

    getNomeClasse() {
        return this.nomeClasse;
    }

    getRender() {
        alert("Falta implementar o getRender()!");
    }

    setComponenteTab(e) {
        this.htmlRender = e;
    }

    getComponenteTab() {
        return this.htmlRender;
    }

    setElementId(id) {
        this.elementId = id;
    }

    getElementId() {
        return this.elementId;
    }

    destroy() {}
}
